import React, { Component, Fragment } from 'react';

import intl from 'react-intl-universal';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Alert from '@mui/material/Alert';

import Typography from '@mui/material/Typography';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { getToken } from "../actions/getTokenActions";
import CheckRefresh from './CheckRefresh';




import Avatar from '@mui/material/Avatar';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

import SwitchDashboard from './SwitchDashboard';

class Home extends Component {
  static displayName = Home.name;

  constructor (props) {
    super(props);
    this.state = {
      loginstep: 0,
      used_username: "",
      nouser: false
    };

  }

  

  handleresetlogin = () => {
    
    this.setState({
      used_username: "",
      loginstep: 0
    }); 
  }

  handlenormallogin = (event) => {
    event.preventDefault()
      let loginstring = {username: event.currentTarget.user_name.value, password: event.currentTarget.password.value};
      this.props.getToken(loginstring);
  }


  handlefourlogin = (event) => {
    event.preventDefault()
    
      let loginstring = {username: event.currentTarget.user_name.value, password: event.currentTarget.password.value, username2: event.currentTarget.user_name2.value, password2: event.currentTarget.password2.value};
      this.props.getToken(loginstring);
  }

  handlefirststep = (event) => {
    event.preventDefault()
      let loginstring = {username: event.currentTarget.user_name.value};
      //console.log(loginstring, event.currentTarget.user_name.value)
      this.getfoureyes(loginstring, event.currentTarget.user_name.value) 
  }




  getfoureyes (params, username)  {
    let apiurl = window.apiurl
    fetch("https://"+apiurl+"/api/Token/getauthmode", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
      })
      
        .then(res => res.json())
        .then(json => {
          if (json.status === 401){
            this.setState({
              nouser: true,
              loginstep: 0
            });
          }

          if (!json.isFourEyes && json.status !== 401){
            this.setState({
              loginstep: this.state.loginstep + 1,
              used_username: username
            });
          }

          if (json.isFourEyes && json.status !== 401){
            this.setState({
              loginstep: this.state.loginstep + 2,
              used_username: username
            });
          }
            
        })
        .catch(function(error) {
            console.log(error);
          });         
      }



      

      

  render () {

    //console.log(this.props)
    const passworderror = this.props.pwerror.message
   // console.log(passworderror)

if (this.props.apitoken !== null) {
      return (
        <React.Fragment>
           <CheckRefresh />
         <SwitchDashboard apitoken={this.props.apitoken} />
        </React.Fragment>
        ); 
      } 



if (this.state.loginstep === 0 && !this.props.islogin) {
      return (
<Fragment>
  <CheckRefresh />
        <Grid container component="main" sx={{ height: '100vh' }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: 'url(../images/mainpic.jpg)',
            backgroundRepeat: 'no-repeat',
            backgroundColor: (t) =>
              t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
              <Avatar sx={{ m: 1, bgcolor: 'light' }}>
              <LockOutlinedIcon />
            </Avatar>
          <Typography component="h1" variant="h5">
          {intl.get('LOGIN_HEADLINE')}
        </Typography>
        <p> {intl.get('LOGIN_USER_DESC')}</p>
        {this.state.nouser &&
           <Alert severity="error">{intl.get('LOGIN_USER_NOUSER_DESC')}</Alert>
        }


        <Divider variant="middle"/>
        <Box component="form" onSubmit={this.handlefirststep}  Validate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="user_name"
            label={intl.get('LOGIN_LABLE_USER')}
            name="user_name"
            autoComplete="email"
            autoFocus
          />
          
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            {intl.get('LOGIN_SUBMIT_USER')}
          </Button>
         
        </Box>
          </Box>
        </Grid>
      </Grid>
    </Fragment>
    )
}

if (this.state.loginstep === 1 && !this.props.islogin) {
  return (
<Fragment>
<CheckRefresh />
        <Grid container component="main" sx={{ height: '100vh' }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: 'url(../images/mainpic.jpg)',
            backgroundRepeat: 'no-repeat',
            backgroundColor: (t) =>
              t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
              <Avatar sx={{ m: 1, bgcolor: 'light' }}>
              <LockOutlinedIcon />
            </Avatar>
    <Typography component="h1" variant="h5">
    {intl.get('LOGIN_HEADLINE')}
    </Typography>
    <p> {intl.get('LOGIN_USER_PW_DESC')}</p>
    <Divider variant="middle"/>
    <Box component="form" onSubmit={this.handlenormallogin}  Validate sx={{ mt: 1 }}>
      <TextField
        margin="normal"
        required
        fullWidth
        id="user_name"
        label={intl.get('LOGIN_LABLE_USER')}
        name="user_name"
        autoComplete="email"
        value={this.state.used_username}
        autoFocus
      />
       <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label={intl.get('LOGIN_LABLE_PASSWORD')}
            type="password"
            id="password"
            autoComplete="current-password"
          />
      
      {passworderror === "401" &&
           <Alert severity="error">{intl.get('LOGIN_ERROR_WRONGPW')}</Alert>
      }
      
     
      <Button
        type="submit"
        fullWidth
        variant="contained"
        sx={{ mt: 3, mb: 2 }}
      >
        {intl.get('LOGIN_SUBMIT_ANMELDEN')}
      </Button>
      <hr />
      <Button
        onClick={()=>this.handleresetlogin()}
        fullWidth
        color="info"
        variant="contained"
        sx={{ mt: 3, mb: 2 }}
      >
        Username zurücksetzten
      </Button>
     
            </Box>
          </Box>
        </Grid>
      </Grid>
      </Fragment>
)
}

if (this.state.loginstep === 2 && !this.props.islogin) {
  return (
<Fragment>
<CheckRefresh />
        <Grid container component="main" sx={{ height: '100vh' }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: 'url(../images/mainpic.jpg)',
            backgroundRepeat: 'no-repeat',
            backgroundColor: (t) =>
              t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
              <Avatar sx={{ m: 1, bgcolor: 'light' }}>
              <LockOutlinedIcon />
            </Avatar>
    <Typography component="h1" variant="h5">
    {intl.get('LOGIN_HEADLINE')}
    </Typography>
    <p>{intl.get('LOGIN_USER_DESC')}</p>
    <Divider variant="middle" />
    <Box component="form" onSubmit={this.handlefourlogin}  Validate sx={{ mt: 1 }}>
      <TextField
        margin="normal"
        required
        fullWidth
        id="user_name"
        label={intl.get('LOGIN_LABLE_USER')}
        name="user_name"
        autoComplete="email"
        value={this.state.used_username}
        autoFocus
      />
       <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label={intl.get('LOGIN_LABLE_PASSWORD')}
            type="password"
            id="password"
            autoComplete="current-password"
          /> <hr />
          <Typography component="h1" variant="h5">
          {intl.get('LOGIN_LABLE_PASSWORD')}
    </Typography>
<p>{intl.get('LOGIN_USER2_DESC')}</p>
<TextField
        margin="normal"
        required
        fullWidth
        id="user_name2"
        label={intl.get('LOGIN_LABLE_USER')}
        name="user_name2"
        autoComplete="email"
        autoFocus
      />
       <TextField
            margin="normal"
            required
            fullWidth
            name="password2"
            label={intl.get('LOGIN_LABLE_PASSWORD')}
            type="password"
            id="password2"
            autoComplete="current-password"
          />

  {passworderror === "401" &&
           <Alert severity="error">{intl.get('LOGIN_ERROR_WRONGPW')}</Alert>
      }
      
     
      <Button
        type="submit"
        fullWidth
        variant="contained"
        sx={{ mt: 3, mb: 2 }}
      >
        {intl.get('LOGIN_SUBMIT_ANMELDEN')}
      </Button>

      <hr />
      <Button
        onClick={()=>this.handleresetlogin()}
        color="info"
        fullWidth
        variant="contained"
        sx={{ mt: 3, mb: 2 }}
      >
        {intl.get('LOGIN_BUTTON_RESET')}
      </Button>
     
      </Box>
          </Box>
        </Grid>
      </Grid>
      </Fragment>
)
}
    
     




  
}
}

const mapStateToProps = state => ({
  state: state,
  apitoken: state.gettocken.apitoken,
  pwerror: state.gettocken.pwerror

});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    getToken: getToken
    }, dispatch);
}


export default connect(mapStateToProps,mapDispatchToProps)(Home);

